import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';
import logo2 from '../../../img/logo.png';
import axios from 'axios';
import NavBar from '../../../components/NavBar';
import WishlistPage from './WishlistPage';
import Auth from '../../../components/Auth';
import LogMasuk from '../../../components/LogMasuk';

function Wishlist() {
  const [login, setLogin] = useState(true);
  const [loading, setLoading] = useState(true);
  const [ownerEmail, setOwnerEmail] = useState('');
  const { id } = useParams();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
      .then(response => {
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, [id]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Wishlist | PanggilanMajlis.com</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div>
        <Auth id={id} setLogin={setLogin} setOwnerEmail={setOwnerEmail} />
        {login ? (
          <div>
            <>
              {loading && (
                <div className="fixed inset-0 h-screen w-full bg-white bg-opacity-80 flex flex-col items-center justify-center space-y-5">
                  <FaSpinner className="text-4xl text-secondary animate-spin" />
                  <img src={logo2} alt="Logo" className="h-12 mb-4" />
                </div>
              )}
              <NavBar />
              <div className="md:p-24 py-24">
                <WishlistPage />
              </div>
            </>
          </div>
        ) : (
          <div>
            <LogMasuk ownerEmail={ownerEmail} setLogin={setLogin} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Wishlist;
